<!-- vim:set et sw=4 ts=4: -->
<template>
    <div id="login-page" class="content">
        <div class="login-panel">
            <form @submit.prevent="submit">
                <p>
                    <label>User ID
                        <input type="text" name="user" v-model="username">
                    </label>
                </p>
                <p>
                    <label>Password
                        <input type="password" name="password" v-model="password">
                    </label>
                </p>
                <p class="error" v-if="loginError">
                    Incorrect username or password
                </p>
                <p class="small">
                    <router-link to="/forgot-password">Forgot Password or User ID</router-link>
                </p>
                <p>
                    <button>Log In</button>
                </p>
                <p class="register">
                    <router-link to="/register">Register for Access</router-link>
                </p>
            </form>
        </div>
        <div class="info-panel">
            <h3>Corporate and Institutional Trust</h3>
            <p>
                At WSFS Institutional Services, we understand your
                organization's need for high-quality, value-added services and
                products that can protect your assets, increase your income and
                further your strategic interests.
            </p>
            <p><a href="https://www.wsfsbank.com/business-services/corporate-institutional-trusts" target="_blank" rel="noopener">Read More</a></p>
        </div>
    </div>
</template>
<script>
import axios from 'axios'

export default {
    name: 'login-page',
    data() {
        return {
            username: '',
            password: '',
            loginError: false,
        }
    },
    methods: {
        async submit() {
            this.loginError = false
            try {
                let r = await axios.post('/api/login', {username: this.username, password: this.password})

                if (r.status == 200) {
                    this.$store.dispatch('setUser', r.data.user)

                    if (r.data.user.reset_pw_next) {
                        this.$router.push('/reset-password')
                        return
                    }

                    this.$router.push('/')
                }
            }
            catch (ex) {
                this.loginError = true
            }
        }
    }
}
</script>
<style lang="scss">
@import "../scss/include-media";

#login-page {
    padding: 50px 100px;
    @include media("<=tablet") {
        padding: 50px;
    }
    &.content {
        @include media(">tablet") {
            max-width: 65vw;
        }
    }

    display: flex;
    flex-flow: column;
    
    @include media(">phone") {
        flex-flow: row nowrap;
        .login-panel {
            flex: 1 1 50%;
            padding-right: 98px;
            border-right: solid 2px #E5E5E5;
        }
        .info-panel {
            flex: 1 1 50%;
            padding-left: 100px;
        }
    }
    p {
        &.small {
            font-size: 0.85rem;
            text-align: right;
        }
        &.register {
            text-align: center;
        }
        &.error {
            color: #E53935;
        }
    }

    button {
        display: block;
        width: 100%;
    }

}
</style>
